import { FC } from 'react';

import { SPALink } from '@hh.ru/redux-spa-middleware';
import Button, { ButtonScale } from 'bloko/blocks/button';

import { Letter, LetterGroupType } from 'src/models/searchCatalogList';
import { SearchTypeGenitive } from 'src/types/search/common';

interface LetterLinkProps {
    catalogType: SearchTypeGenitive;
    letter: Letter;
}

const LetterLink: FC<LetterLinkProps> = ({ catalogType, letter }) => {
    const { letterGroupType, letterGroupId, alias, hasItems, selected } = letter;

    const letterGroupPath =
        letterGroupType === LetterGroupType.ETC ? LetterGroupType.ETC : `${letterGroupType}/${letterGroupId}`;
    const letterPath = `/${catalogType}/${letterGroupPath.toLowerCase()}`;

    return selected ? (
        <Button scale={ButtonScale.Small} pressed>
            {alias.toUpperCase()}
        </Button>
    ) : (
        <Button Element={SPALink} to={letterPath} isSeoLink scale={ButtonScale.Small} disabled={!hasItems}>
            {alias.toUpperCase()}
        </Button>
    );
};

export default LetterLink;
